import { partFlag, type PagePart } from '@/features/storefront/sections/parts';

/**
 * Whether a "Notify me when available" part on this page stands in for the
 * add-to-cart button while the chosen option is sold out.
 *
 * Read by the add-to-cart part, which draws nothing in that case: a greyed-out
 * button over an email box says "sold out" twice. Only a part the shopper can
 * see counts - a hidden one is the merchant saying they do not want the box.
 */
export function notifyMeTakesOver(parts: readonly PagePart[] | undefined): boolean {
  return (parts ?? []).some(
    (part) =>
      part.type === 'product_notify_me' && part.visible !== false && partFlag(part, 'hide_add_to_cart'),
  );
}

/** A loose check, before the server's; it only has to catch a typo. */
export const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
